// extracted by mini-css-extract-plugin
export default {"container":"IconTableItem-module__container___mIa26","icon":"IconTableItem-module__icon___PvG6F","name":"IconTableItem-module__name___RcHvC"};